import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import './i18n'; // initialise i18next before the app renders
import App from './App';

// French is the only supported language
document.documentElement.dir  = 'ltr';
document.documentElement.lang = 'fr';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
